<template>
  <div class="dod15">

    <div class="dod_mock" ref="pc">
      <div class="dod_mock_header">
        <div class="dod_mock_header_bg" ref="pcHeaderBg"></div>
        <h4 ref="pcHeaderTitle">Title</h4>
      </div>
    </div>

  </div>
</template>

<script>
import anime from 'animejs'

export default {
  name: 'Day15',

  data: () => ({
  }),

  methods: {
    pcAnime() {
      anime({
        targets: this.$refs.pcHeaderBg,
        scaleY: [
          { value: [1, 1.4], delay: 800, duration: 800, easing: 'cubicBezier(0.86, 0, 0.07, 1)' },
          { value: [1], delay: 800, easing: 'easeOutElastic(1, 0.7)', duration: 800 }
        ],
        loop: true
      })
      anime({
        targets: this.$refs.pcHeaderTitle,
        translateY: [
          { value: ['0%', '150%'], delay: 800, duration: 800, easing: 'cubicBezier(0.86, 0, 0.07, 1)' },
          { value: '0%', delay: 800, easing: 'easeOutElastic(1, 0.7)', duration: 800 }
        ],
        loop: true
      })
    }
  },

  beforeDestroy() {
  },

  mounted() {
    this.pcAnime()
  }
}
</script>

<style scoped lang="scss">
.dod15 {
  @include FR_FULLSIZE;
}

.dod_mock {
  @include FR_CENTER(xy);
  position: absolute;
  width: 40vw;
  height: (40vw / 1.75);
  background-color: red;
  border-radius: 5px;
}

.dod_mock_header {
  position: absolute;
  top: 5px;
  left: 5px;
  width: calc(40vw - 10px);
  height: calc(40vw / 4);
  background-color: white;
  border-radius: 2px;
  box-shadow: 0 5px 10px rgba(#000000, 0.1);
}

.dod_mock_header_bg {
  @include FR_FULLSIZE;
  background-color: white;
  transform-origin: center top;
  border-radius: 2px;
}

.dod_mock_header > h4 {
  @include WEBFONT(normal, 800);
  position: absolute;
  left: 0.2em;
  bottom: 0.2em;
  font-size: 2.5vw;
  line-height: 1;
  transform-origin: center top;
}
</style>
